module.exports = __webpack_public_path__ + "static/favicon-b2e44c683cfaddf38c995fe63adcecbf.ico";